import { matchPath, useLocation } from "react-router-dom";
import { routes } from "../routes";

export function useBreadcrumbs(context = {}) {
  const { pathname } = useLocation();

  const breadcrumbs = [];

  routes.forEach((route) => {
    const match = matchPath({ path: route.path, end: false }, pathname);

    if (!match) return;

    let label = route.label;
    if (typeof route.breadcrumb === "function") {
      label = route.breadcrumb({ ...context, ...match.params });
    } else if (route.breadcrumbParam && match.params?.[route.breadcrumbParam]) {
      label = match.params[route.breadcrumbParam];
    }

    breadcrumbs.push({
      label,
      path: match.pathnameBase,
      isVirtual: !!route.isVirtual,
      hideWhenExact: !!route.hideBreadcrumb,
      isExact: match.pathnameBase === pathname,
    });
  });

  return breadcrumbs;
}
